var galleryCaption = new Swiper(".cc-video-wrapper", { 
  slidesPerView: "auto", 
  loop: true,
  spaceBetween: 16, 
  watchSlidesProgress: true,
  breakpoints: {
    0: { 
      spaceBetween: 9
    },
    1024: { 
      spaceBetween: 16
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var testimonialSwiper = new Swiper(".cc-testimonial-slider", { 
    slidesPerView: 1,
    simulateTouch: false,
    spaceBetween: 15,
    loop: true, 
    navigation: {
      nextEl: ".testimonial-button-next",
      prevEl: ".testimonial-button-prev",
    },
    on: {
      slideChange: function () {
        var currentSlide = this.realIndex + 1;
        var totalSlides = this.slides.length - this.loopedSlides * 2; // Get actual count
        console.log(`Current slide: ${currentSlide} of ${totalSlides}`);
        
        document.querySelector(".current-slide").textContent = currentSlide;
        document.querySelector(".total-slides").textContent = totalSlides;
      },
      init: function () {
        let totalSlides = this.slides.length - this.loopedSlides * 2;
        document.querySelector(".total-slides").textContent = totalSlides;
        document.querySelector(".current-slide").textContent = 1; // Start from 1
      }
    }
  });
});


$('.cc-video .cc-play-btn').click(function() { 
   $('.cc-video video').not(this).each(function() {
    this.pause();  
     this.controls = false;  
     $(this).parentsUntil('.swiper-slide').parent().removeClass('active-slide'); 
    });
    $(this).siblings('.cc-player-wrapper').children('video').trigger('play').prop("controls", true); 
    $(this).siblings('.cc-player-wrapper').parentsUntil('.swiper-slide').parent().addClass('active-slide');
});

$(document).ready(function(){
    $(".content-with-center-img .text-with-icon").click(function () { 
        $('.content-with-center-img .text-with-icon').removeClass('active');
        $('.content-with-center-img .cc-2-accordion').slideUp();
 
        var activeImg = $(this).attr("data-for");
        $('.content-with-center-img .background-img img').hide();
        $('.content-with-center-img .background-img #' + activeImg).show(); 
 
        $(this).addClass('active');
        $(this).siblings('.cc-2-accordion').slideDown();  
    });
});

$('.cc-main-product .accordion-item .accordion-title').click(function(){
  $(this).toggleClass('active');
  $(this).siblings('.accordion-tab').slideToggle();
});

$('.cc-steps .cc-content-block h3').click(function(){
  $(this).toggleClass('active');
  $(this).siblings('.metafield-rich_text_field').slideToggle();
});
